export var BetaFlags;
(function (BetaFlags) {
    BetaFlags["IpWhitelist"] = "ipWhitelist";
    BetaFlags["MobileGroupUI"] = "mobileGroupUI";
    BetaFlags["AutoDowngradeQuality"] = "autoDowngradeQuality";
    BetaFlags["RoutedSession"] = "routed-session";
})(BetaFlags || (BetaFlags = {}));
